
const StatsSection = () => {
  const stats = [
    {
      icon: 'ri-community-line',
      number: '50+',
      label: 'Agglomérations partenaires',
    },
    {
      icon: 'ri-user-heart-line',
      number: '2000+',
      label: 'Particuliers accompagnés',
    },
    {
      icon: 'ri-building-line',
      number: '500+',
      label: 'Professionnels soutenus',
    },
    {
      icon: 'ri-star-line',
      number: '95%',
      label: 'Taux de satisfaction',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-white border-t border-gray-light">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6">
                <i className={`${stat.icon} text-4xl md:text-5xl text-primary-light`}></i>
              </div>
              <div className="text-4xl md:text-5xl font-bold text-primary mb-2 md:mb-3">
                {stat.number}
              </div>
              <div className="text-sm md:text-base text-gray-dark font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
